export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/components/dashboard/Dashboard'),
    meta: {
      title: '管理者ダッシュボード'
    }
  },
  {
    path: '/adminDashboard',
    name: 'admin Dashboard',
    component: () => import('@/components/dashboard/adminDashboard'),
    meta: {
      title: '運営者ダッシュボード'
    }
  },
  {
    path: '/board/home',
    name: 'Board',
    component: () => import('@/components/menus/board/home')
  },
  {
    path: '/video',
    name: 'video',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/videoPlayer'),
    props: (route) => ({
      videoSource: route.query.videoSource
    })
  },
  {
    path: '/kakao/chat/open',
    name: 'kakaoChatOpen',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/menus/channel/kakao/CreateChannelButton'),
    props: (route) => ({
      plusFriendId: route.query.plusFriendId,
      brandId: route.query.brandId,
      extra: route.query.extra,
      bot: route.query.bot,
      event: route.query.event
    })
  },
  {
    path: '/naver/chat/open',
    name: 'naverChatOpen',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/components/menus/channel/naver/NaverChatOpen'),
    props: (route) => ({
      naverTalkId: route.query.naverTalkId,
      chatRoomId: route.query.chatRoomId
    })
  },
  {
    path: '/chat/close',
    name: 'chatClose',
    component: () => import('@/components/menus/ChatClose')
  },
  {
    path: '/external/chat_messages',
    name: 'external_chat_messages',
    meta: {
      requiresAuth: false
    },
    component: () => import('../../components/external/chat_messages')
  },
  {
    path: '/brand/addCategory',
    name: 'createCategory',
    component: () => import('@/components/menus/CreateCategory')
  },
  {
    path: '/agent/agent_approval',
    name: 'agent_approval',
    component: () => import('@/components/menus/agent/agent_approval')
  },
  {
    path: '/brand/template',
    name: 'template',
    component: () => import('@/components/menus/brand/template')
  },
  {
    path: '/dataTrend/data_trend_admin',
    name: 'dataTrend',
    component: () => import('@/components/menus/dataTrend/data_trend_admin')
  },
  {
    path: '/agent/category_management',
    name: 'category_management',
    component: () => import('@/components/menus/agent/category_management')
  },
  {
    path: '/brand/brand_management',
    name: 'brand_management',
    component: () => import('@/components/menus/brand/brand_management')
  },
  {
    path: '/brand/moduleManagement',
    name: 'moduleManagement',
    component: () => import('@/components/menus/brand/moduleManagement')
  },
  {
    path: '/brand/moduleManagement/channel',
    name: 'moduleChannel',
    component: () => import('@/components/menus/brand/moduleChannel')
  },
  {
    path: '/brand/plan',
    name: 'brandPlan',
    component: () => import('@/components/menus/brand/brandPlan')
  },
  {
    path: '/management/member',
    name: 'management_member',
    component: () => import('@/views/management/brand/Member')
  },
  {
    path: '/management/member/modify/:id',
    name: 'management_member_modify',
    component: () => import('@/views/management/brand/MemberModify')
  },
  {
    path: '/management/role',
    name: 'management_role',
    component: () => import('@/views/management/brand/Role')
  },
  {
    path: '/management/role/new',
    name: 'management_role_new',
    component: () => import('@/views/management/brand/RoleForm')
  },
  {
    path: '/management/role/modify/:id',
    name: 'management_role_modify',
    component: () => import('@/views/management/brand/RoleForm')
  },
  {
    path: '/report/agents_status',
    name: 'agents_status',
    component: () => import('@/components/menus/brand/agents_status')
  },
  {
    path: '/agent/brand_schedule_management',
    name: 'brand_schedule_management',
    component: () => import('@/components/menus/brand/brand_schedule_management')
  },
  {
    path: '/channel/channel_button',
    name: 'channel_button',
    component: () => import('@/components/menus/channel/channel_button')
  },
  {
    path: '/channel/channel_connection',
    name: 'channel_connection',
    component: () => import('@/components/menus/channel/channel_connection')
  },
  {
    path: '/channel/channel_connection_line',
    name: 'channel_connection_line',
    component: () => import('@/components/menus/channel/channel_connection_line')
  },
  {
    path: '/report/consult_status',
    name: 'consult_status',
    component: () => import('@/components/report/consult_status')
  },
  {
    path: '/report/consult_statistics',
    name: 'consult_statistics',
    component: () => import('@/components/report/consult_statistics')
  },
  {
    path: '/report/consult_history',
    name: 'brand_chat_list',
    component: () => import('@/components/menus/chat/consult_history')
  },
  {
    path: '/report/delay_status',
    name: 'brand_agent_delay_status',
    component: () => import('@/components/menus/chat/delay_status')
  },
  {
    path: '/report/consult_evaluate',
    name: 'consult_evaluate',
    component: () => import('@/components/report/consult_evaluate')
  },
  {
    path: '/report/consult_quality',
    name: 'consult_quality',
    component: () => import('@/components/report/consult_quality')
  },
  {
    path: '/report/survey_report',
    name: 'survey_report',
    component: () => import('@/components/menus/survey/survey_report')
  },
  {
    path: '/report/call_history',
    name: 'call_history',
    component: () => import('@/components/report/CallConsultHistory')
  },
  {
    path: '/report/call_statistics',
    name: 'call_statistics',
    component: () => import('@/components/report/CallConsultStatistics')
  },
  {
    path: '/report/call_status',
    name: 'call_status',
    component: () => import('@/components/report/CallConsultStatus')
  },
  {
    path: '/report/call_agent_statistics',
    name: 'call_agent_statistics',
    component: () => import('@/components/report/CallAgentStatistics')
  },
  {
    path: '/report/call_history_status',
    name: 'call_history_status',
    component: () => import('@/components/report/CallHistoryStatus')
  },
  {
    path: '/report/call_service_level',
    name: 'call_service_level',
    component: () => import('@/components/report/CallServiceLevelStatistics')
  },
  {
    path: '/notice/brand_notice',
    name: 'brand_notice',
    component: () => import('@/components/menus/notice/brand_notice')
  },
  {
    path: '/notice/list',
    name: 'notice_list',
    component: () => import('@/components/menus/notice/Notice')
  },
  {
    path: '/notice/write',
    name: 'notice_write',
    component: () => import('@/components/menus/notice/Registration')
  },
  {
    path: '/notice/modify/:id',
    name: 'notice_modify',
    component: () => import('@/components/menus/notice/Registration')
  },
  {
    path: '/brand/brand_auto_message',
    name: 'brand_auto_message',
    component: () => import('@/components/menus/brand/brand_auto_message')
  },
  {
    path: '/brand/brand_counsel_distribution_management',
    name: 'brand_counsel_distribution_management',
    component: () => import('@/components/menus/brand/brand_counsel_distribution_management')
  },
  {
    path: '/brand/brand_counsel_type_management',
    name: 'brand_counsel_type_management',
    component: () => import('@/components/menus/brand/brand_counsel_type_management')
  },
  {
    path: '/brand/brand_ban_word_management',
    name: 'brand_ban_word_management',
    component: () => import('@/components/menus/brand/brand_ban_word_management')
  },
  {
    path: '/system/brand_management',
    name: 'system_management',
    component: () => import('@/components/menus/system/brand_management')
  },
  {
    path: '/system/sub_brand_management',
    name: 'system_brand_management',
    component: () => import('@/components/menus/system/sub_brand_management')
  },
  {
    path: '/system/system_notice',
    name: 'system_notice',
    component: () => import('@/components/menus/system/system_notice')
  },
  {
    path: '/system/system_approval',
    name: 'system_approval',
    component: () => import('@/components/menus/system/system_approval')
  },
  {
    path: '/system/system_auto_message',
    name: 'system_auto_message',
    component: () => import('@/components/menus/system/system_auto_message')
  },
  {
    path: '/brand/brand_status_management',
    name: 'brand_status_management',
    component: () => import('@/components/menus/system/brand_status_management')
  },
  {
    path: '/billing/billing_management',
    name: 'billing_management',
    component: () => import('@/components/menus/billing/billing_management')
  },
  {
    path: '/chatbot/chatbot_intro',
    name: 'chatbot_intro',
    component: () => import('@/components/menus/chatbot/chatbot_intro')
  },
  {
    path: '/system/system_module_management',
    name: 'system_module_management',
    component: () => import('@/components/menus/system/system_module_management')
  },
  {
    path: '/system/ticket_agent_management',
    name: 'ticket_agent_management',
    component: () => import('@/components/menus/system/system_ticket_agent_management')
  },
  /* 메시지 관리 */
  {
    path: '/message/send_message_test',
    name: 'send_message',
    meta: {
      requiresAuth: true
    },
    component: () => import('@/components/menus/message/send_message')
  },
  {
    path: '/message/send_kakao_instant_message',
    name: 'kakao_alarmTalk',
    meta: {
      requiresAuth: true
    },
    component: () => import('@/components/menus/message/send_kakao_instant_message')
  },
  {
    path: '/message/send_message_statistics',
    name: 'send_message_statistics',
    meta: {
      requiresAuth: true
    },
    component: () => import('@/components/menus/message/send_message_statistics')
  },

  /* 신규 개발 */
  {
    path: '/message/send_message',
    component: () => import(/* webpackChunkName: "SendMessage" */ '@/views/message/SendMessage'),
    name: 'setting_message',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/message/setting_template',
    component: () => import(/* webpackChunkName: "SetTemplate" */ '@/views/message/SetTemplate'),
    name: 'setting_template',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/message/send_history',
    component: () => import(/* webpackChunkName: "SendHistory" */ '@/views/message/SendHistory'),
    name: 'send_history',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/message/message_template_management',
    component: () => import('@/views/message/MessageTemplateManagement'),
    name: 'message_template_management',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/message/message_template_management/registration', // 상담 설정 > 상담 정보 템플릿 관리 > 등록
    name: 'registration',
    component: () => import(/* webpackChunkName: "SetTemplate" */ '@/views/message/SetTemplate')
  },
  {
    path: '/message/message_template_management/update', // 상담 설정 > 상담 정보 템플릿 관리 > 수정
    name: 'update',
    component: () => import(/* webpackChunkName: "SetTemplate" */ '@/views/message/SetTemplate')
  },
  {
    path: '/message/send_statistics',
    component: () => import(/* webpackChunkName: "SendStatistics" */ '@/views/message/SendStatistics'),
    name: 'send_statistics',
    meta: {
      requiresAuth: true
    }
  },
  /* //메시지 관리 */
  {
    path: '/billing/send_message_statistics',
    name: 'billing_message_statistics',
    meta: {
      requiresAuth: true
    },
    component: () => import('@/components/menus/message/send_message_statistics')
  },
  {
    path: '/billing/billing_talk',
    name: 'billing_talk',
    meta: {
      requiresAuth: true
    },
    component: () => import('@/components/menus/billing/billing_talk')
  },
  {
    path: '/billing/billing_customerAuthentication',
    name: 'billing_customerAuthentication',
    meta: {
      requiresAuth: true
    },
    component: () => import('@/components/menus/billing/billing_customerAuthentication')
  },
  {
    path: '/system/kakao_channel_management',
    name: 'kakao_channel_management',
    component: () => import('../../components/menus/system/kakao_channel_management')
  },
  {
    path: '/admin/brand/brand_management',
    name: 'admin_brand_management',
    component: () => import('@/views/admin/management/brand/BrandManagement')
  },
  {
    path: '/admin/brand/brand_registration',
    name: 'admin_brand_registration',
    component: () => import('@/views/admin/management/brand/BrandRegistration')
  },
  {
    path: '/admin/brand/brand_modify/:id',
    name: 'admin_brand_modify',
    component: () => import('@/views/admin/management/brand/BrandRegistration')
  },
  {
    path: '/admin/management/member',
    name: 'admin_management_member',
    component: () => import('@/views/admin/management/brand/Member')
  },
  {
    path: '/admin/management/member/modify/:id',
    name: 'admin_management_member_modify',
    component: () => import('@/views/admin/management/brand/MemberModify')
  },
  {
    path: '/admin/management/role',
    name: 'admin_management_role',
    component: () => import('@/views/admin/management/brand/Role')
  },
  {
    path: '/admin/management/role/new',
    name: 'admin_management_role_new',
    component: () => import('@/views/admin/management/brand/RoleForm')
  },
  {
    path: '/admin/management/role/modify/:id',
    name: 'admin_management_role_modify',
    component: () => import('@/views/admin/management/brand/RoleForm')
  },
  {
    path: '/admin/brand/system_log',
    name: 'admin_system_log',
    component: () => import('../../components/menus/admin/brand/system_log')
  },
  {
    path: '/admin/brand/privacy_inquiry_log',
    name: 'admin_privacy_inquiry_log',
    component: () => import('../../components/menus/admin/brand/PrivacyInquiryLog')
  },
  {
    path: '/admin/management/system_member',
    name: 'admin_management_system_member',
    component: () => import('@/views/admin/management/brand/SystemMember')
  },
  {
    path: '/admin/management/system_member/modify/:id',
    name: 'admin_management_system_member_modify',
    component: () => import('@/views/admin/management/brand/SystemMemberModify')
  },
  {
    path: '/admin/approval/module_management',
    name: 'admin_module_management',
    component: () => import('../../components/menus/admin/approval/AdminChannelManagement')
  },
  {
    path: '/admin/approval/auto_message_management',
    name: 'admin_auto_message',
    component: () => import('../../components/menus/admin/approval/auto_message')
  },
  {
    path: '/admin/approval/cloud_call_connect',
    name: 'admin_cloud_call_connect',
    component: () => import('../../components/menus/admin/approval/CloudCallConnect')
  },
  {
    path: '/admin/approval/cloud_call_connect/registration',
    name: 'admin_cloud_call_connect_registration',
    component: () => import('../../components/menus/admin/approval/CloudCallConnectRegistration')
  },
  {
    path: '/admin/channel/brand_call_management',
    name: 'admin_brand_call_management',
    component: () => import('../../components/menus/admin/approval/BrandCallManagement')
  },
  {
    path: '/admin/channel/kakao_channel_management',
    name: 'admin_kakao_channel_management',
    component: () => import('../../components/menus/admin/channel/kakao_channel_management')
  },
  {
    path: '/admin/channel/kakao_brand_talk_management',
    name: 'admin_kakao_brand_talk_management',
    component: () => import('../../components/menus/admin/channel/kakao_brand_talk_management')
  },
  {
    path: '/admin/system_notice',
    name: 'admin_system_notice',
    component: () => import('../../components/menus/admin/system_notice')
  },
  {
    path: '/admin/dataTrend/data_trend',
    name: 'admin_dataTrend',
    component: () => import('@/components/menus/admin/dataTrend/data_trend_admin')
  },
  {
    path: '/admin/ticket/ticket_agent_management',
    name: 'admin_ticket_agent_management',
    component: () => import('../../components/menus/admin/ticket/agent_management')
  },
  {
    path: '/admin/ticket/ticket_task_type_management',
    name: 'admin_ticket_task_type_management',
    component: () => import('../../components/menus/admin/ticket/task_type_management')
  },
  {
    path: '/admin/billing/billing_management',
    name: 'admin_billing_management',
    component: () => import('@/components/menus/admin/billing/billing_management')
  },
  // {
  //   path: '/admin/billing/send_message_statistics',
  //   name: 'admin_billing_message_statistics',
  //   component: () => import('@/components/menus/admin/billing/send_message_statistics')
  // },
  {
    path: '/admin/billing/send_message_statistics_v2',
    name: 'admin_billing_message_statistics_v2',
    component: () => import('@/components/menus/admin/billing/send_message_statistics_v2')
  },
  {
    path: '/admin/billing/billing_talk',
    name: 'admin_billing_talk',
    component: () => import('@/components/menus/admin/billing/billing_talk')
  },
  {
    path: '/admin/billing/billing_customerAuthentication',
    name: 'admin_billing_customerAuthentication',
    component: () => import('@/components/menus/admin/billing/billing_customerAuthentication')
  },
  {
    path: '/admin/billing/billing_alarm',
    name: 'admin_billing_alarm',
    component: () => import('@/components/menus/admin/billing/billing_alarm')
  },
  {
    path: '/admin/billing/billing_totalInfo',
    name: 'admin_billing_totalInfo',
    component: () => import('@/components/menus/admin/billing/billing_totalInfo')
  },
  {
    path: '/admin/billing/BillingCommunicationInfo',
    name: 'BillingCommunicationInfo',
    component: () => import('@/components/menus/admin/billing/BillingCommunicationInfo')
  },
  {
    path: '/admin/billing/billing_brand_talk',
    name: 'admin_billing_brand_talk',
    component: () => import('@/components/menus/admin/billing/billing_brand_talk')
  },
  {
    path: '/icomsys/video_counseling',
    name: 'icomsys_video_counseling',
    component: () => import('@/components/menus/icomsys/video_counseling')
  },
  {
    path: '/icomsys/category_management',
    name: 'icomsys_category_management',
    component: () => import('@/components/menus/icomsys/category_management')
  },
  {
    path: '/icomsys/fetch_counseling_list',
    name: 'icomsys_fetch_counseling_list',
    component: () => import('@/components/menus/icomsys/fetch_counseling_list')
  },
  {
    path: '/icomsys/counseling_statistics',
    name: 'icomsys_counseling_statistics',
    component: () => import('@/components/menus/icomsys/counseling_statistics')
  },
  {
    path: '/call/operation',
    name: 'Call Operation',
    component: () => import(/* webpackChunkName: "callOperation" */ '@/views/callOperation/Index')
  },
  {
    path: '/agent/call_consultant_setting', // 상담 설정 > call 채널 담당자 설정
    name: 'call_consultant_setting',
    component: () => import(/* webpackChunkName: "callConsultantSetting" */ '@/views/agent/callConsultantSetting')
  },
  {
    path: '/client/claim_information_management', // 고객 관리 > 클레임 정보 관리
    name: 'claim_information_management',
    component: () => import(/* webpackChunkName: "claimInformationManagement" */ '@/views/client/claimInformationManagement')
  },
  {
    path: '/client/claim_information/:pageType', // 고객 관리 > 클레임 정보 관리 수정 / 등록
    name: 'claim_information_update',
    component: () => import(/* webpackChunkName: "claimInformationCreateUpdate" */ '@/views/client/claimInformationUpdate')
  },
  {
    path: '/agent/reservation_management', // 상담 설정 > Call 예약 상담 관리 > 예약 상담 관리
    name: 'reservation_management',
    component: () => import(/* webpackChunkName: "reservationManagement" */ '@/views/agent/reservationManagement')
  },
  {
    path: '/agent/reservation_registration', // 상담 설정 > Call 예약 상담 관리 > 예약 상담 등록
    name: 'reservation_registration',
    component: () => import(/* webpackChunkName: "reservationRegistration" */ '@/views/agent/reservationRegistration')
  },
  {
    path: '/agent/consulting_template', // 상담 설정 > 상담 정보 템플릿 관리
    name: 'consulting_template',
    component: () => import(/* webpackChunkName: "consultingTemplate" */ '@/views/agent/consultingTemplate')
  },
  {
    path: '/agent/consulting_template/registration', // 상담 설정 > 상담 정보 템플릿 관리 > 등록
    name: 'consulting_template_registration',
    component: () => import(/* webpackChunkName: "consultingTemplateRegistration" */ '@/views/agent/consultingTemplateRegistration')
  },
  {
    path: '/agent/consulting_template/update', // 상담 설정 > 상담 정보 템플릿 관리 > 수정
    name: 'consulting_template_update',
    component: () => import(/* webpackChunkName: "consultingTemplateUpdate" */ '@/views/agent/consultingTemplateUpdate')
  },
  {
    path: '/agent/consulting_type', // 상담 설정 > 상담 유형 관리
    name: 'consulting_type',
    component: () => import(/* webpackChunkName: "consultingType" */ '@/views/agent/consultingType')
  },
  {
    path: '/agent/consulting_type/registration', // 상담 설정 > 상담 유형 등록
    name: 'consulting_type_registration',
    component: () => import(/* webpackChunkName: "consultingTypeRegistration" */ '@/views/agent/consultingTypeRegistration')
  },
  {
    path: '/agent/consulting_type/update', // 상담 설정 > 상담 유형 수정
    name: 'consulting_type_update',
    component: () => import(/* webpackChunkName: "consultingTypeUpdate" */ '@/views/agent/consultingTypeUpdate')
  },
  {
    path: '/operation',
    name: 'Operation Board',
    component: () => import('@/components/operation/operation_board')
  },
  {
    path: '/operation/commerce/process',
    name: 'commerceProcess',
    component: () => import(/* webpackChunkName: "commerceProcess" */'@/components/operation/fragments/right/commerceProcess'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/brand/commerce_management',
    name: 'commerce_management',
    component: () => import(/* webpackChunkName: "CommerceManagement" */'@/views/management/brand/CommerceManagement')
  },
  {
    path: '/brand/alarm',
    name: 'alarm_setting',
    component: () => import(/* webpackChunkName: "AlarmSetting" */'@/views/management/brand/Alarm')
  },
  {
    path: '/inquiry_desk',
    name: 'inquiry_desk',
    component: () => import(/* webpackChunkName: "InquiryDesk" */'@/views/inquiryDesk/InquiryDesk')
  },
  {
    path: '/customer',
    name: 'customer',
    component: () => import('@/components/menus/customer/customer')
  },
  {
    path: '/lineCustomer',
    name: 'lineCustomer',
    component: () => import('@/components/menus/customer/lineCustomer')
  },
  {
    path: '/websiteCustomer',
    name: 'websiteCustomer',
    component: () => import('@/components/menus/customer/websiteCustomer')
  },
  {
    path: '/customer/customerRegister',
    name: 'customerRegister',
    component: () => import('@/components/menus/customer/customerRegister')
  },
  {
    path: '/customer/customerInfo',
    name: 'customerInfo',
    component: () => import('@/components/menus/customer/customerRegister')
  },
  {
    path: '/lineCustomer/customerInfo',
    name: 'lineCustomerInfo',
    component: () => import('@/components/menus/customer/customerRegister')
  },
  {
    path: '/websiteCustomer/customerInfo',
    name: 'websiteCustomerInfo',
    component: () => import('@/components/menus/customer/customerRegister')
  },
  {
    path: '/marketing/pushList',
    name: 'marketingPushList',
    component: () => import('@/components/menus/marketing/marketingPushTemplate')
  },
  {
    path: '/marketing/pushEdit',
    name: 'marketingPushEdit',
    component: () => import('@/components/menus/marketing/marketingPushTemplateEdit')
  },
  {
    path: '/marketing/pushInfo',
    name: 'marketingPushInfo',
    component: () => import('@/components/menus/marketing/marketingPushTemplateEdit')
  },
  {
    path: '/marketing/line/intro',
    name: 'marketingFlexIntro',
    component: () => import('@/components/menus/marketing/marketingFlexIntro')
  },
  {
    path: '/marketing/sendMarketing',
    name: 'sendMarketing',
    component: () => import('@/components/menus/marketing/marketingSendMarketing')
  },
  {
    path: '/marketing/sendStatus',
    name: 'sendStatus',
    component: () => import('@/components/menus/marketing/marketingSendStatus')
  },
  {
    path: '/marketing/richMenuList',
    name: 'richMenuTemplate',
    component: () => import('@/components/menus/marketing/richMenuTemplate')
  },
  {
    path: '/marketing/richMenuEdit',
    name: 'richMenuEdit',
    component: () => import('@/components/menus/marketing/richMenuEdit')
  },
  {
    path: '/reservation/management',
    name: 'reservationManagement',
    component: () => import('@/components/menus/reservation/reservationManagement')
  },
  {
    path: '/reservation/list',
    name: 'reservationList_',
    component: () => import('@/components/menus/reservation/reservationList')
  },
  {
    path: '/reservationRegister',
    name: 'ReservationRegister',
    component: () => import('@/components/menus/reservation/reservationRegister.vue')
  },
  {
    path: '/reservation/timeList',
    name: 'reservationTimeList',
    component: () => import('@/components/menus/reservation/reservationTimeList')
  },
  {
    path: '/calendar/management',
    name: 'calendarManagement',
    component: () => import('@/components/menus/calendar/calendarManagement')
  },
  {
    path: '/calendar/auth',
    name: 'calendarAuth',
    component: () => import('@/components/menus/calendar/calendarAuth')
  },
  {
    path: '/calendar/listGoogle',
    name: 'calendarList',
    component: () => import('@/components/menus/calendar/calendarListGoogle')
  },
  {
    path: '/marketing/sendInfo',
    name: 'marketingSendInfo',
    component: () => import('@/components/menus/marketing/marketingSendInfo')
  }
]



// WEBPACK FOOTER //
// ./src/router/subRoutes/default.js